import { useFormik } from 'formik'
import { Form, FormLabel, Spinner } from 'react-bootstrap'
import * as Yup from 'yup'
import { useGetFiltersQuery, usePreProcessMutation } from '../../redux/api/pipelineApi.js'

// Validation Schema
const validationSchema = Yup.object().shape({
  filter: Yup.string().required('filter is required'),
})

const PreProcess = ({ setStep }) => {
  const { data: filters = [], isLoading: loadingFilters } = useGetFiltersQuery()
  const [preProcess, { isLoading }] = usePreProcessMutation()

  const handleSubmit = async (values, { setFieldError }) => {
    try {
      await preProcess({ filter: values.filter })
      setStep((s) => s + 1)
    } catch (err) {
      setFieldError('form', err?.data?.error || err?.data?.message || 'An error occurred during upload')
    }
  }

  const formik = useFormik({
    initialValues: { filter: '' },
    validationSchema,
    onSubmit: handleSubmit,
  })

  return (
    <Form onSubmit={formik.handleSubmit}>
      {/* Filters Selector */}
      <Form.Group className='mb-3'>
        <FormLabel>Filter</FormLabel>
        <Form.Select name='filter' value={formik.values.filter} onChange={formik.handleChange} onBlur={formik.handleBlur} disabled={loadingFilters}>
          <option value=''>Select a filter</option>
          {filters?.available_filters?.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </Form.Select>
        {formik.touched.filter && formik.errors.filter && <div className='text-danger'>{formik.errors.filter}</div>}
      </Form.Group>

      {formik.errors.form && <div className='text-danger mb-3'>{formik.errors.form}</div>}

      <div className='mt-2 d-flex align-items-center gap-2'>
        <button type='button' className='common-btn py-2 flex-grow-1' onClick={() => setStep((s) => s - 1)} disabled={isLoading}>
          Back
        </button>

        <button type='submit' className='common-btn py-2 flex-grow-1' disabled={isLoading}>
          {isLoading ? (
            <div className='d-flex align-items-center justify-content-center gap-2'>
              <Spinner animation='border' size='sm' />
              Processing...
            </div>
          ) : (
            'Process'
          )}
        </button>
      </div>
    </Form>
  )
}

export default PreProcess
